<template>
  <card :title="cardTitle">
    <div
      v-if="isDirector"
      class="headLink"
      @click="toDireEvaluation"
    >
      部门考评
    </div>
    <div class="list__layout">
      <div class="list__layout__left">
        <div
          v-if="isLoading"
          class="list__content--loading"
        >
          <img src="@assets/images/loading.gif">
          <div>正在加载...</div>
        </div>
        <a-table
          v-if="!isLoading && okrList.length"
          row-key="rowNum"
          :columns="columns"
          :data-source="okrList"
          :loading="loading"
          :pagination="false"
        >
          <!-- <template
            slot="title"
            slot-scope="text, record"
          >
            <span v-if="record.year && !record.quarter">
              {{ `${record.year}年度考评` }}
            </span>
            <span v-if="record.year && record.quarter">
              {{ `${record.year}年Q${record.quarter}季度业绩目标` }}
            </span>
          </template> -->
          <template
            slot="selfEvaluationState"
            slot-scope="text, record"
          >
            <div v-if="record.quarter">
              <!-- 季度自评状态 -：-2 未提交：-1 待提交：0 已提交：1  -->
              <a
                v-if="record.selfEvaluationState===1"
                class="stateOk"
                @click="() => selfEvaluationView(record.id)"
              >已自评</a>
              <a
                v-else-if="record.selfEvaluationState===0"
                class="stateIng"
                @click="() => selfEvaluationEdit(record.id)"
              >待自评</a>
              <span
                v-else-if="record.selfEvaluationState===-1"
                class="stateNo"
              >超时未自评</span>
              <span v-else>-</span>
            </div>
            <div v-else>
              <!-- 年度自评状态 -：-2 未提交：-1 待提交：0 已提交：1  -->
              <a
                v-if="record.selfEvaluationState===1"
                class="stateOk"
                @click="() => selfEvaluationInYearView(record.id)"
              >已自评</a>
              <a
                v-else-if="record.selfEvaluationState===0"
                class="stateIng"
                @click="() => selfEvaluationInYearEdit(record.id)"
              >待自评</a>
              <span
                v-else-if="record.selfEvaluationState===-1"
                class="stateNo"
              >未自评</span>
              <span v-else>-</span>
            </div>
          </template>
          <template
            slot="operation"
            slot-scope="text, record"
          >
            <div v-if="record.quarter">
              <a
                v-if="!record.onlyRead && record.selfEvaluationState!==1"
                class="list__button line"
                @click="() => showUpload(record.id, record.year, record.quarter)"
              >
                上传
              </a>
              <a
                v-if="!record.onlyRead && record.selfEvaluationState!==1"
                class="list__button line"
                @click="() => handleClickEdit(record.id, record.year, record.quarter)"
              >
                编辑
              </a>
              <a
                :class="!record.id ? 'list__button list__button--disabled' : 'list__button'"
                @click="() => handleClickView(record.id)"
              >
                查看
              </a>
            </div>
          </template>
        </a-table>
        <div
          v-if="!isLoading && !okrList.length"
          class="list__content--empty"
        >
          <img src="@assets/images/empty.png">
          <div>咦 ~ 真的什么都没有耶…</div>
        </div>
      </div>
      <div class="list__layout__right">
        <div class="list__r__title">
          搜索他人业绩目标
        </div>
        <div class="list__layout__search">
          <a-select
            show-search
            :value="searchField"
            placeholder="搜索姓名"
            style="width: 100%;"
            :show-arrow="false"
            :filter-option="false"
            :allow-clear="true"
            :get-popup-container="getPopupContainer"
            @change="handleChange"
            @search="handleSearch"
            @select="handleSelect"
          >
            <div
              v-if="isSearching"
              slot="notFoundContent"
            >
              正在搜索...
            </div>
            <a-select-option
              v-for="user in searchData"
              v-else
              :key="user.userId"
            >
              <span class="search-head">
                <avatar
                  :src="user.image"
                  :width="36"
                  :height="36"
                />
              </span>
              {{ user.userName }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <Upload
        :parame="uploadData"
        :show="isShow"
        :step="refreshStep"
        @close="closeUpload"
      />
    </div>
  </card>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Table, Select, message, Button } from 'ant-design-vue'
import debounce from 'lodash/debounce'
import Card from '@components/card/index.vue'
import Avatar from '@components/avatar/index.vue'
import Upload from '@components/upload/index.vue'

Vue.use(Table)
Vue.use(Select)
Vue.use(Button)

const columns = [{
  title: '标题',
  //  生成复杂数据的渲染函数
  customRender: (t, r) => {
    return r.quarter ? `${r.year}年Q${r.quarter}季度业绩目标` : `${r.year}年度考评`
  },
  dataIndex: 'quarter',
}, {
  title: '业绩目标提交时间',
  dataIndex: 'updateTime',
  customRender: (t, r) => {
    if (!r.updateTime || (r.updateTime && !r.quarter)) {
      r.updateTime = '-'
    }
    return r.updateTime
  },
}, {
  title: '自评入口',
  dataIndex: 'selfEvaluationState',
  scopedSlots: { customRender: 'selfEvaluationState' },
}, {
  title: '操作',
  dataIndex: 'operation',
  className: 'column-operate',
  scopedSlots: { customRender: 'operation' },
}]

export default {
  name: 'OkrList',
  components: {
    Card,
    Avatar,
    Upload,
  },
  props: {},
  data() {
    this.fetchUser = debounce(this.fetchUser, 1000)
    return {
      userId: null,
      okrList: [],
      columns,
      loading: false,
      userName: '',
      listUser: '',
      searchData: [],
      fetching: false,
      // 解决select组件弹窗随滚动条滚动的问题
      getPopupContainer(triggerNode) {
        return triggerNode.parentNode
      },
      searchField: void (0),
      isSearching: false,
      isLoading: true,
      isShow: false,
      uploadData: {},
      refreshStep: null,
      isDirector: false,
      deListY: '', // 主管评可查看最近年度
      deListQ: 0, // 主管评可查看最近季度
    }
  },
  computed: {
    ...mapState({
    //   currentTime: state => state.serverTime,
      currentUser: state => state.userId,
    }),
    /**
     * card 上显示的 title，如果有 userId，就是看他人的 OKR，否则就是自己的
     * @return {String} 返回 title
     */
    cardTitle() {
      const title = this.userId ? `${this.listUser}的目标` : '我的目标'
      document.title = this.userId ? `${title}的目标列表 - ` : '我的目标列表'
      return title
    },
  },
  async created() {
    const userId = this.$route.params.userId
    this.userId = userId

    try {
      this.isLoading = true
      // 判断当前季度是否有okr的时候，获取服务器时间作为基准的时间
      await this.$store.dispatch('getServerTime')

      await this.fetchOkrList()
    } catch (error) {
      const msg = error.errorMessage || error.message || '网络错误'
      message.error(msg)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    /**
     * 获取 OKR 列表
     */
    async fetchOkrList() {
      const userId = this.userId || ''
      const result = await this.$api.okr.getList({
        userId,
      })
      // 判断不是自己的列表不显示自评列
      if (this.userId) {
        this.columns = columns.filter(item => {
          return item.dataIndex !== 'selfEvaluationState'
        })
      } else {
        // this.userId为undefined时，请求接口判断是否拥有主管权限
        const { isDirector, endQuarter } = await this.$api.okr.getTimeRange()
        if (isDirector) {
          this.isDirector = isDirector
          this.deListY = endQuarter.year
          this.deListQ = endQuarter.quarter
        }
      }
      // 原使用id为rowkey，因id可能为空，因此自定义一列编号给table用做rowkey
      const temArr = result.quarterInfoDtoList
      for (let i = 0; i < temArr.length; i++) { temArr[i].rowNum = i }
      this.$set(this, 'okrList', temArr)
      // eslint-disable-next-line
      console.log('temArr', temArr)
      this.listUser = result.userName
    },

    // 点击编辑按钮，如果id为false，则打开新页面进入创建okr页面，否则打开新页面进入编辑页面
    handleClickEdit (id, year, quarter) {
      if (!id) {
        const { href } = this.$router.resolve({
          name: 'NewOKR',
          params: { year, quarter },
        })
        window.open(href, '_blank')
      } else {
        const { href } = this.$router.resolve({
          name: 'EditOKR',
          params: { okrId: id, year, quarter },
        })
        window.open(href, '_blank')
      }
    },
    // 点击查看按钮，新开页面进入详情页面
    handleClickView (id) {
      if (!id) {
        return
      }

      const { href } = this.$router.resolve({
        name: 'OKRDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 点击上传
    showUpload(id, year, quarter) {
      // eslint-disable-next-line
      console.log(typeof (id), typeof (year), typeof (quarter))
      // 不同季度点击上传按钮时id可能会没有，因此先清空对象，再存入当前内容
      this.uploadData = {}
      this.refreshStep = 1
      this.isShow = true
      this.uploadData.year = year
      this.uploadData.quarter = quarter
      if (id) {
        this.uploadData.id = id
      }
    },
    // 关闭上传
    closeUpload() {
      this.isShow = false
      this.fetchOkrList()
    },
    // 点击“待提交” 编辑自评
    selfEvaluationEdit(id) {
      if (!id) {
        return
      }
      const { href } = this.$router.resolve({
        name: 'EditSelfEvaluation',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 点击“已提交” 查看自评详情
    selfEvaluationView(id) {
      if (!id) {
        return
      }
      const { href } = this.$router.resolve({
        name: 'SelfEvaluationDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 查询列表以及结果渲染
    async fetchUser(value) {
      const { currentUser } = this

      try {
        let searchResult = await this.$api.okr.search({
          userName: value,
        })

        searchResult = searchResult.filter(user => user.userId !== currentUser)

        // 暂时不支持模糊查询，结果返回目前最多只有一条，兼容处理
        this.$set(this, 'searchData', searchResult || [])
      } catch (error) {
        const msg = error.errorMessage || error.message || '网络错误'
        message.error(msg)
      } finally {
        this.isSearching = false
      }
    },
    handleChange(v) {
      // 如果没有 v 就是清空，重置搜索状态
      if (!v) {
        this.resetSearchBox()
      }
    },
    resetSearchBox() {
      this.searchField = void (0)
      this.$set(this, 'searchData', [])
      this.isSearching = false
    },
    async handleSearch(value) {
      if (!value) {
        this.resetSearchBox()
        return
      }

      this.isSearching = true
      this.searchField = value
      this.$set(this, 'searchData', [])

      if (value) {
        this.fetchUser(value)
      }
    },
    // 点击查询结果新开页面打开该用户OKR列表
    handleSelect(key) {
      const { href } = this.$router.resolve({
        name: 'OthersOKR',
        params: { userId: key },
      })
      window.open(href, '_blank')

      // 重置搜索状态
      this.resetSearchBox()
    },
    // 点击进入考评列表
    toDireEvaluation() {
      this.$router.push({
        path: 'direEvaluationList',
        query: {
          year: this.deListY,
          quarter: this.deListQ,
        },
      })
    },
    // 点击”待自评“进入年度自评编辑页面
    selfEvaluationInYearEdit(id) {
      if (!id) {
        return
      }
      const { href } = this.$router.resolve({
        name: 'EditYearSelfEvaluation',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
    // 点击“已提交” 查看年度自评详情
    selfEvaluationInYearView(id) {
      if (!id) {
        return
      }
      const { href } = this.$router.resolve({
        name: 'YearSelfEvaluationDetail',
        params: { okrId: id },
      })
      window.open(href, '_blank')
    },
  },
}
</script>

<style lang="less">
.list {
  &__button {
    &.line::after {
      content: '';
      display: inline-block;
      margin:0 8px;
      vertical-align: middle;
      width:1px;
      height: 15px;
      background-color: #ddd;
    }
    &--disabled {
      cursor: not-allowed;
      color:rgba(0,0,0,0.25);

      &:hover,
      &:active,
      &:focus {
        color:rgba(0,0,0,0.25);
      }
    }
  }

  &__content {
    &--loading,
    &--empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      min-height: 234px;
      background: #fff;

      > img {
        margin-bottom: 24px;
      }
    }

    &--loading {
      padding: 80px;

      > img {
        width: 160px;
        height: 160px;
      }
    }

    &--empty {
      height: 100%;
      color: #888;

      > img {
        width: 79px;
        height: 108px;
      }
    }
  }
}
.list__layout{
  display:flex;
  &__left {
    flex:1;
    margin-right: 15px;
    padding-right: 15px;
    border-right: #ddd 1px solid;
    td {
      background-color: #fff;
    }
  }
  &__right{width:160px;}
  &__search{position: relative;}
}
.list__r__title{font-size:14px; font-weight: bold; margin-bottom: 12px;}
.search-head{display: inline-block; margin-right:10px; vertical-align: middle;
}
th.column-operate,
td.column-operate {
  padding-right: 40px;
  text-align: right !important;
}

.ant-table-thead > tr > th, .ant-table-tbody > tr > td {
  &:first-child {
    padding-left: 32px;
  }
  &:last-child {
    padding-right: 32px;
  }
}

.ant-table-thead > tr > th {
  border-bottom: 0;
}
.ant-table-tbody > tr:last-child > td {
  border-bottom: 0;
}
.stateNo{color:#999;}
.stateNo::before,.stateIng::before,.stateOk::before{content: ""; display:inline-block; width:8px; height: 8px; margin-right: 6px; border-radius: 50%;}
.stateNo::before{background-color: #999; }
.stateIng::before{background-color: #F5222D; }
.stateOk::before{background-color: #52C41A; }
.headLink{position: absolute; top:0; left:91px; font-size:16px; font-weight: 600; line-height: 48px;
&:hover{color:#0064FA; cursor: pointer;}}
</style>
